 import { ViewChild,Component, OnInit ,ViewEncapsulation, AfterViewInit, OnDestroy, Input } from '@angular/core';
import { AuthService  } from '../services/auth.service';
 
// import { EventService } from '../../services/event/event.service'; 
import { Title }     from '@angular/platform-browser';
import {Router,NavigationEnd,ActivatedRoute } from "@angular/router";
declare var $:any;

// import { ToastrService } from 'ngx-toastr';
import { MessageService } from '../message.service';
import{ArticleService} from '../services/article.service';
import {Observable, pipe, throwError, Subscription} from 'rxjs'; 
// import { Res,IProfile } from 'src/app/entity';
import { distinctUntilChanged } from 'rxjs/operators';
import {AppSettings} from '../settings';
// import { HomeService } from 'app/services/home.service';
import {HomeService} from '../services/home.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'site-header',
  templateUrl: './siteHeader.component.html',
 
  encapsulation:ViewEncapsulation.None,
 
})

export class SiteHeaderComponent implements OnInit,AfterViewInit,OnDestroy{

  edittr:boolean =false;

   subscription:Subscription;
   
  
   
   @Input() notification:any=[];

   @Input() user:any='';

   token:string ='';

 
   searchTxt:any='';

   currentPage:any

   deletedId:any=[]
   userId:any;
   external:boolean=false

  userName='';
  navigationsType=[];
  notificationval:any=[];

  dataUrl:any
  isMshow:boolean=false
  isMasquerade:boolean=false
  uId:any;
 

    constructor( private _authService: AuthService,private _router: Router,private toastr: ToastrService,private messageService:MessageService,private articleService:ArticleService,private homeservice:HomeService) { 

     this.dataUrl = AppSettings.PORTAL_ENDPOINT

      try{
		  
 
        let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;
  
        if(!tokenA) throw 'Error in parse';
        
        if(!JSON.parse(tokenA)) throw 'Error in json parse';
      
        tokenA = JSON.parse(tokenA);

        this.token = tokenA.token;
       
      }catch(exc){

        this._router.navigate(['/login']);


      }

      this.subscription = this.messageService.getMessage().subscribe(message => { 
	
        if(message!=undefined && message!=false && message.text.type=="reset_search"){
  
          this.searchTxt= '';
          

        }

        if(message!=undefined && message!=false && message.text.type=="currentpage"){
  
          this.currentPage = message.text.details;
          

        }


      });


    }

    ngOnDestroy(){

      this.subscription.unsubscribe();


    }

    saveName(name:string){

       
      this.edittr=!this.edittr ;
      this.user=name;
    }
	
	  saveName2(){

    
    }

    ngOnInit(){

        this.homeservice.homeData(this.token).subscribe( (res)=>{

          if(res.status=='success'){
            localStorage.setItem('pending_external', res.pending_external ? res.pending_external : 0);
            console.log('res.role',res.role)
            if(res.role.length>0){
              if(res.role[0].toLowerCase()=='admin' || res.role[0].toLowerCase()=='publisher' || res.role[0].toLowerCase()=='reviewer'){
                this.isMshow = true
              }else if(res.user['masquerade']==true){
                this.isMshow = true
              }
              else{
                this.isMshow = false
              }
            }else{
              if(res.user['masquerade']==true){
                this.isMshow = true
              }
            }
            
            this.isMasquerade = res.user.masquerade
            this.uId = res.user.id
            
    
          }else{        
            this.toastr.error(res.message, '', {timeOut: 3000});
          }
        });
      
     
      this._router.events.pipe(distinctUntilChanged((previous: any, current: any) => {
        if(current instanceof NavigationEnd) {
          if(previous.url != current.url){
            let prev = previous.url.split('?')
            let curr = current.url.split('?')
            let newprev = prev[0].split('/')
            let newcurr = curr[0].split('/')

            if(newprev[1]=='article' && newprev[3]=='view'){

              let data2={
                article:newprev[2],
                event:'avend',
                source:'web',
                token:this.token
              }
              this.articleService.analytics(data2).subscribe( (res)=>{
                if(res.status=='success' ){
          
                }
              })
              
            }
            if(newprev[1]=='newsletter' && newprev[3]=='view'){
             
              let data3={
                newsletter:newprev[2],
                event:'nvend',
                source:'web',
                token:this.token
              }
              this.articleService.analytics(data3).subscribe( (res)=>{
          
                if(res.status=='success' ){
          
                }
              })
            }

          }
          return previous.url === current.url;
        }
        return true;
  
       })).subscribe((x: any) => {  
        
      });
    }

    navigation(){
     
      try{
		  
 
        let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;
  
        if(!tokenA) throw 'Error in parse';
        
        if(!JSON.parse(tokenA)) throw 'Error in json parse';
      
        tokenA = JSON.parse(tokenA);

        this.token = tokenA.token;
        let data={
          token:tokenA.token,
          // limit:10,
          // 'page':'profile'
        }

        this.articleService.getUserGroup(data).subscribe( (res)=>{

          if(res.status=='success'){
          
            this.userId=res.user.id
            if(res.user.external=='Yes'){
              this.external=true
            }

            if(this.external==true){
              this._router.navigate(['/exprofile']);
              this.messageService.sendMessage({'type':'exprofile','userId':this.userId,'external':1,'admin':false,'data':res});
            }else{
              this._router.navigate(['/profile']);
              this.messageService.sendMessage({'type':'profile','data':res})
            }
           
           
          }else{        
            this.toastr.error(res.message, '', {timeOut: 5000});
          }
        });
      


      }catch(exc){

        this._router.navigate(['/login']);


      }
    
     
    }


   callbackNotification(){

    }

    nextP(){
      
      $('.dropdown,.dropdown-menu').removeClass('show');
      $('[data-toggle="popover"]').popover('hide');

      $('.tooltip-custom').tooltip("hide");
  
      
      this._router.navigate(['/notification']);
    }
  
    ngAfterViewInit() {
  
     //console.log(this.ee);
  	  		  //this.ee.nativeElement.focus();


      $(function(){
		  
		  /*
		  $('body').on('click', function (e) {
			  
 			  
			  
			  
			  if(document.getElementById("pradip")!=null && document.getElementById("pradip").contains(e.target) && e.target.id !='pradip-bad'){
   
             e.preventDefault();
            e.stopPropagation();

          }
			  
			  
 
            });*/


       // $('body').click(function(e){

      
        //  console.log(document.getElementById("mob_menu_btn").contains(e.target));

        //  if(!document.getElementById("mob_menu_btn").contains(e.target)){

   
           // e.preventDefault();
            //e.stopPropagation();

        //  }

        


      //  })

      // Get arbitrary element with id "my-element"

// Listen for click events on body
$('body').click(function(et){

      

     if (document.getElementById("left_sidebar")!=null && document.getElementById("left_sidebar").contains(et.target) ) {
        
         et.stopPropagation();
          

     }
     
     if($(et.target).closest('li').hasClass('hide_leftsidebar') && $('#mob_menu_btn').hasClass('menu-open')){
        

      $('#mob_menu_btn').trigger('click');

         
     }
});




        $("body").on('click','#mob_menu_btn',function(event){
  
     
 

           
  
      
             $("#left_sidebar").removeClass("active");
              

            // $("#left_sidebar").removeClass("mob-menu-bg");
     
 


              if($(this).hasClass('menu-open')){

                $(this).removeClass("menu-open");

              }else{

                $(this).addClass("menu-open");

                $("#left_sidebar").addClass("active");

               // $("#left_sidebar").addClass("mob-menu-bg");
                
              }

              //$("#mob-toogle-btn").toggleClass("menu-open");
              //$("#left_sidebar").toggleClass("mob-menu-bg");

              event.stopPropagation();
              });

              // $('body').click(function(e) {
              //   $("#left_sidebar").removeClass("active");
              //   $("#left_sidebar").removeClass("mob-menu-bg");

              //   e.stopPropagation();
              // });
  
      });


      $(document).ready(function(){

        let scripturl = this.dataUrl + 'themes/custom/mmeportal/js/launcher.js'

        $.getScript(scripturl, function(){

        
          window['mmeportal_launcher']();

        });
       
       }.bind(this));


    }

   
 

    logout() {

      var isConfirmed = confirm("You will be looged out from all other applications.Do you want to proceed?");
      if(isConfirmed){
        try{
    
    
          let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;
      
          if(!tokenA) throw 'Error in parse';
          
          if(!JSON.parse(tokenA)) throw 'Error in json parse';
        
          tokenA = JSON.parse(tokenA);

          let data={
            token:tokenA.token,
           
          }
  
          this.articleService.getUserGroup(data).subscribe( (res)=>{
  
            if(res.status=='success'){
              let data2={
                event:'logout',
                source:'web',
                token:tokenA.token,
              }
              this.articleService.analytics(data2).subscribe( (res)=>{
          
                if(res.status=='success' ){
          
                }
              })
           
            this._authService.logout(tokenA.token).subscribe( (result) =>{
                
                if(result.status=='success'){
                
                  localStorage.clear();
                  if(res.user.external=='Yes'){
                    this._router.navigate(['/vlogin']);
                  }else{
                    this._router.navigate(['/login']);
                  }
      
                    
                }else{
      
                  if(res.user.external=='Yes'){
                    this._router.navigate(['/vlogin']);
                  }else{
                    this._router.navigate(['/login']);
                  }

                }
              
    
             }) ;
             
            }else{        
              this.toastr.error(res.message, '', {timeOut: 5000});
            }
          });
                   
         
    
        }catch(exc){
    
          localStorage.clear();
         // this.toastr.error('Something went wrong', '', {timeOut: 3000});
          this._router.navigate(['/login']);  
    
        }
      }else{
        return false;
      }
    
      }

      search(){

        if(this.searchTxt.length > 0){

          this.messageService.sendMessage({'type':'search','details':this.searchTxt,'currentPage':this.currentPage});
          this._router.navigate(['/search']);

        }
        
       
      }


      delete(id:any){
       
         
        let data={
          token:this.token,
          reqData:{
            id:id, 
            archive:true,
            'page':'notification'
          }
        
          //offset:this.record_offset
        }


        this.articleService.removeNotification(data).subscribe( (res)=>{
                


          if(res.status=='success'){

            let catI = this.notification.list.findIndex( (elm) => { 
              return  elm.id == id
            });
              
            
            this.notification.list.splice(catI,1);
           
            this.notification.count = this.notification.count-1;
            
            this.toastr.success('Deleted', '', {timeOut: 3000});

          }
        });

      }

      Masquerade(){
        this._router.navigate(['/masquerade']);
      }

      

     
     

}
